import { ChangeDetectionStrategy, Component, input } from '@angular/core';

// Deckt sowohl das Bundle-TYPE_STYLE (Funktional/Nicht-funktional/Bug/Verbesserung,
// page-anforderungen-liste.jsx:40-45) als auch die restlichen REQUIREMENT_TYPE_DEFAULTS
// (Story/Sub-Task/Fachlich/Technisch) ab. `custom` ist der neutrale Fallback fuer
// projekt-lokale Freitext-Typen (NEX-1016) — ohne ihn wuerde ein importierter
// "Epic" blau als "Funktional" gefaerbt (NEX-1086 Review, sgraetz C1).
export type RequirementTypeKind =
  | 'funktional'
  | 'nicht-funktional'
  | 'bug'
  | 'verbesserung'
  | 'story'
  | 'substory'
  | 'fachlich'
  | 'technisch'
  | 'custom';

@Component({
  selector: 'app-type-pill',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="type-pill" [attr.data-kind]="kind()" data-testid="type-pill">
      <span class="type-pill__dot" aria-hidden="true"></span>
      {{ label() }}
    </span>
  `,
  styles: `
    :host {
      display: inline-flex;
    }

    .type-pill {
      display: inline-flex;
      align-items: center;
      gap: 0.4375rem;
      padding: 0.3125rem 0.6875rem;
      border-radius: 999px;
      font-size: 0.75rem;
      font-weight: 600;
      white-space: nowrap;
      background: var(--to-blue-bg);
      color: var(--to-blue-fg);

      &[data-kind='nicht-funktional'],
      &[data-kind='technisch'] {
        background: var(--to-purple-bg);
        color: var(--to-purple-fg);
      }
      &[data-kind='bug'] {
        background: var(--to-red-bg);
        color: var(--to-red-fg);
      }
      &[data-kind='verbesserung'],
      &[data-kind='fachlich'] {
        background: var(--to-cyan-bg);
        color: var(--to-cyan-fg);
      }
      &[data-kind='substory'] {
        background: var(--to-warn-bg);
        color: var(--to-warn-fg);
      }
      &[data-kind='custom'] {
        background: var(--to-border-soft);
        color: var(--to-text);
      }
    }

    .type-pill__dot {
      width: 0.375rem;
      height: 0.375rem;
      border-radius: 50%;
      flex-shrink: 0;
      background: var(--to-blue-dot);

      .type-pill[data-kind='nicht-funktional'] &,
      .type-pill[data-kind='technisch'] & {
        background: var(--to-purple-dot);
      }
      .type-pill[data-kind='bug'] & {
        background: var(--to-red-dot);
      }
      .type-pill[data-kind='verbesserung'] &,
      .type-pill[data-kind='fachlich'] & {
        background: var(--to-cyan-dot);
      }
      .type-pill[data-kind='substory'] & {
        background: var(--to-amber-deep);
      }
      .type-pill[data-kind='custom'] & {
        background: var(--to-text-muted);
      }
    }
  `,
})
export class TypePillComponent {
  readonly kind = input.required<RequirementTypeKind>();
  readonly label = input.required<string>();
}
